<!--
 * @Author: xing.huang
 * @Date: 2021-01-20 18:38:57
 * @LastEditTime: 2023-04-11 15:34:14
 * @LastEditors: xing.huang
 * @Description: 
 * @FilePath: \iMaster-Web\src\views\Organization\UserBase.vue
 * @
-->
<template>
    <div>
        <div class="table_searchbar" id='user-base'>
            <el-row style="margin-left:20px">
                <el-col :span="7">
                    <div class="" @keydown.enter="btnSearch()">
                        <span class="title" style="width: 104px;margin-left: -20px;">手机号/账号： </span>
                        <el-input class="value" style="max-width:180px" size="small" v-model="searchForm.accountName" maxlength="16" placeholder="手机号/账号"></el-input>
                    </div>
                </el-col>
                <el-col :span="7">
                    <div class="" @keydown.enter="btnSearch()">
                        <span class="title">姓名：</span>
                        <el-input class="value" style="max-width:180px" size="small" v-model="searchForm.name" maxlength="16" placeholder="姓名"></el-input>
                    </div>
                </el-col>
                <el-col :span="6">
                    <div class="" @keydown.enter="btnSearch()">
                        <span class="title">工号：</span>
                        <el-input class="value" style="max-width:166px" size="small" v-model="searchForm.employeeId"  maxlength="16" placeholder="工号"></el-input>
                    </div>
                </el-col>
                <el-col :span="4">
                    <div class="buttom-warp" style="text-align:right">
                        <el-button icon="el-icon-search" size="mini" type="primary" @click="btnSearch()">查询</el-button>
                        <el-button icon="el-icon-refresh" size="mini"  @click='clearSearch'>重置</el-button>
                    </div>
                </el-col>
            </el-row>
        </div>
        <el-table  :data="userList"  style="width: 100%" class="deviceTable" >
            <el-table-column prop="name" label="姓名" show-overflow-tooltip min-width="80" ></el-table-column>
            <el-table-column prop="employeeId" label="工号"  min-width="100" show-overflow-tooltip></el-table-column>
            <el-table-column prop="workshopOrganizationName" label="部门" show-overflow-tooltip min-width="80"></el-table-column>
            <el-table-column prop="job" label="职位"  show-overflow-tooltip min-width="60"></el-table-column>
            <el-table-column prop="roleName" label="角色" show-overflow-tooltip min-width="60"></el-table-column>
            <el-table-column prop="sex" :formatter='parseSex' label="性别"  min-width="40"></el-table-column>
            <el-table-column prop="workingState" :formatter='parseUserStatus' label="状态" min-width="40" show-overflow-tooltip ></el-table-column>
            <el-table-column prop="isOrgLeader"   label="部门负责人" show-overflow-tooltip width="120">
                <template slot-scope="scope"> 
                    <span v-if="scope.row.isOrgLeader" style="color:#67C23A;margin-left: 10px;">√</span>
                </template>
            </el-table-column>
        </el-table>
        <div class="page" v-if="userList.length > 0">
            <div class="total_page"><span> 共{{tableTotalPage}}条 10条/页</span></div>
            <div style="margin-top:10px;text-align:right; margin-bottom:20px;" >
                <el-pagination background layout="prev, pager, next" :total="tableTotalPage" @current-change="pageChange" :current-page="tableCurrentPage">
                </el-pagination>
            </div>
        </div> 
    </div>
</template>
<script>
export default {
    name: 'UserBase',
    props:{
        id:Number,
    },
	data () {
        let that = this
        return {
            tableCurrentPage:1,
            tableTotalPage:5,
            userList:[],
            btnPressType: 0,//按钮类型： 0-默认 1-查询 2-重置 3-分页
            searchForm:{
                accountName:null,
                name:null,
                employeeId:null,
            },
        }
    },
    mounted(){
        this.init()
    },
    methods:{
        init(id){
            this.loadUserList(id)
        },
        btnSearch:async function(){
            log(this.id,11111)
            this.tableCurrentPage = 1;
            this.btnPressType = 1
            await this.loadUserList();
        },
        clearSearch(){
            let form = this.searchForm;
            this.btnPressType = 2;
            form.accountName=null
            form.name=null
            form.employeeId=null
        },
        parseUserStatus(rowData){
            let status = rowData.workingState
            let str = ''
            switch(status){
                case 0:
                    str = '在职'
                break;
                case 1:
                    str = '休假'
                break;
                case 2:
                    str = '离职'
                break;
            }
            return str
        },
        parseSex:function(val){
            if(val.sex == 0){
                    return "女";
            }else{
                return "男";
            }
        },
        pageChange:async function(targetPage){
            this.tableCurrentPage = targetPage;
            this.btnPressType = 3;
            await this.loadUserList();
        },
        async loadUserList(id){
            let temp;
            switch (this.btnPressType) {
              case 1:
                temp = commonUtils.cloneObj(this.searchForm);
                this.searchFormTemp = commonUtils.cloneObj(temp);
                break;
              case 0:
                temp ={
                    accountName:null,
                    name:null,
                    employeeId:null,
                };
                break;
              case 2:
                temp = this.searchFormTemp;
                break;
              case 3:
                temp = this.searchFormTemp;
                break;
            }
            if(!id){
                id = this.id
            }
            let {data, code, msg, message,totalPages} = await this.$RequestUtil.getAsync({url: '/api/organization/listUser',type: 'sync', params: {...temp,pageNum:this.tableCurrentPage,pageSize:10,groupId:id,},})
            if (code == 0) {
                this.tableTotalPage = totalPages
                this.userList = data
            } else {
                this.$message.error(msg || message)
            }
        },
    },
    
}
</script>
<style scoped>
.page{
    display: flex;
    justify-content: flex-end;
}
.table_searchbar{
    width:100%;
    margin-top: -10px;
    margin-bottom: 10px;
}
.total_page{
    margin-top: 20px;
    margin-right: 26px;
    color:#606266;
    font-size: 14px;
}

@media screen and (min-width:1100px) and (max-width: 1399px){
    .buttom-warp{
        width: 104%;
    
        position: relative;
        left: 10px;
    }
}
</style>
<style >
@media screen and (min-width:1400px) and (max-width: 1800px){
	#user-base .title{
        font-size: 12px;
    }
    #user-base .value{
        width: 130px;
    }
    #user-base .el-button--mini, #user-base .el-button--mini.is-round {
        padding: 5px 5px;
    }
}
@media screen and (min-width:1100px) and (max-width: 1399px){
	#user-base .title{
        font-size: 12px;
    }
    #user-base .value{
        width: 122px;
    }
    #user-base .el-button--mini, #user-base .el-button--mini.is-round {
        padding: 5px 3px !important;
    }
}

</style>

 


// WEBPACK FOOTER //
// src/views/Organization/UserBase.vue